import { Page } from "@/models/page-models/Page";

export const PurchasingOrderAdmin: Page = {
  "path": "purchasing-order-admin",
  "name": "Purchase Orders",
  "props": {
    "data": {
      "title": "Dashboard",
      "printable": "FALSE",
      "url": "purchasing-order-admin",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Add New PO",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "redirectToCreatePurchaseOrder"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "SUBMITTED",
              "bracketValueFormula": "fn(LENGTH,{{fetchedData.submitted.data}})",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "variable": "formData.submittedPOTable",
                      "label": "SUBMITTED",
                      "disabled": "FALSE",
                      "items": "fetchedData.submitted.data",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "PO #",
                          "type": "url",
                          "url": "fn(CONDITIONAL,fn(LOGICAL,'{{__item.type}}',===,'Spare Parts'),/add-spare-parts-purchase-order/{{__item._id}},/add-purchase-order/{{__item._id}})"
                        },
                        {
                          "value": "__item.actions",
                          "text": "Actions",
                          "type": "actions",
                          "actions": [
                            {
                              "label": "Approve",
                              "onClick": [
                                {
                                  "executionOrder": 1,
                                  "name": "copySelectedTableItem"
                                },
                                {
                                  "executionOrder": 2,
                                  "name": "approvePO"
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "value": "__item.supplier.name",
                          "text": "Supplier Name"
                        },
                        {
                          "value": "__item.purchasedRMs",
                          "text": "Raw Material/Spare Part",
                          "type": "formula",
                          "formula": "fn(CONDITIONAL,fn(NOT,{{__item.rawMaterial}}),{{__item.sparePart.description}},{{__item.rawMaterial.name}})",
                          "multipleItemsVariable": "purchasedRMs"
                        },
                        {
                          "value": "__item.unitQuantity",
                          "text": "Quantity",
                          "type": "formula",
                          "filterType": "unit",
                          "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterial.rawMaterialUnit}},'),==,'SQM'),{{fn(STANDARD_FUNCTIONS,kgToSQM,{{__item.unitQuantity}},{{__item.rawMaterial}})}},{{__item.unitQuantity}})",
                          "filterParam": "fn(CONDITIONAL,fn(NOT,{{__item.rawMaterial}}),{{__item.sparePart.unit}},{{__item.rawMaterial.rawMaterialUnit}})",
                          "multipleItemsVariable": "purchasedRMs"
                        },
                        {
                          "value": "__item.unitPrice",
                          "text": "Unit Price",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currency,fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterial.rawMaterialUnit}},'),==,'SQM'),{{fn(STANDARD_FUNCTIONS,priceKgToSQM,{{__item.unitPrice}},{{__item.rawMaterial}})}},{{__item.unitPrice}}),{{__variable.currencyCode}})",
                          "multipleItemsVariable": "purchasedRMs"
                        },
                        {
                          "value": "__item.price",
                          "text": "Price",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currency,{{{{__item.unitQuantity}}*{{__item.unitPrice}}}},{{__variable.currencyCode}})",
                          "multipleItemsVariable": "purchasedRMs"
                        },
                        {
                          "value": "__item.createdAt",
                          "text": "Date Submitted",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        }
                      ],
                      "tableType": "static",
                      "showActions": true
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "APPROVED",
              "bracketValueFormula": "fn(LENGTH,{{fetchedData.approved.data}})",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "variable": "formData.approvedPOTable",
                      "label": "APPROVED",
                      "disabled": "FALSE",
                      "items": "fetchedData.approved.data",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "PO #",
                          "type": "url",
                          "url": "fn(CONDITIONAL,fn(LOGICAL,'{{__item.type}}',===,'Spare Parts'),/add-spare-parts-purchase-order/{{__item._id}},/add-purchase-order/{{__item._id}})"
                        },
                        {
                          "value": "__item.actions",
                          "text": "Actions",
                          "type": "actions",
                          "width": 250,
                          "actions": [
                            {
                              "label": "no warehouse receipts yet",
                              "priority": "main",
                              "showIf": "fn(LOGICAL,fn(LENGTH,{{__item.receipts}}),==,0)",
                              "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item.receipts}}),==,0)",
                              "onClick": []
                            },
                            {
                              "label": "Upload Receipt",
                              "priority": "main",
                              "showIf": "fn(LOGICAL,fn(LENGTH,{{__item.receipts}}),>,0)",
                              "onClick": [
                                {
                                  "executionOrder": 1,
                                  "name": "copySelectedTableItem"
                                },
                                {
                                  "executionOrder": 2,
                                  "name": "openPoReceiptProofPopup"
                                }
                              ]
                            },
                            {
                              "label": "Complete",
                              "priority": "menu",
                              "onClick": [
                                {
                                  "executionOrder": 1,
                                  "name": "copySelectedTableItem"
                                },
                                {
                                  "executionOrder": 2,
                                  "name": "completePo"
                                }
                              ]
                            }
                          ],
                          "useMenu": true
                        },
                        {
                          "value": "__item.supplier.name",
                          "text": "Supplier Name"
                        },
                        {
                          "value": "__item.purchasedRMs",
                          "text": "Raw Material/Spare Part",
                          "type": "formula",
                          "formula": "fn(CONDITIONAL,fn(NOT,{{__item.rawMaterial}}),{{__item.sparePart.description}},{{__item.rawMaterial.name}})",
                          "multipleItemsVariable": "purchasedRMs"
                        },
                        {
                          "value": "__item.unitQuantity",
                          "text": "Quantity",
                          "type": "formula",
                          "filterType": "unit",
                          "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterial.rawMaterialUnit}},'),==,'SQM'),{{fn(STANDARD_FUNCTIONS,kgToSQM,{{__item.unitQuantity}},{{__item.rawMaterial}})}},{{__item.unitQuantity}})",
                          "filterParam": "fn(CONDITIONAL,fn(NOT,{{__item.rawMaterial}}),{{__item.sparePart.unit}},{{__item.rawMaterial.rawMaterialUnit}})",
                          "multipleItemsVariable": "purchasedRMs"
                        },
                        {
                          "value": "__item.unitPrice",
                          "text": "Unit Price",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currency,fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterial.rawMaterialUnit}},'),==,'SQM'),{{fn(STANDARD_FUNCTIONS,priceKgToSQM,{{__item.unitPrice}},{{__item.rawMaterial}})}},{{__item.unitPrice}}),{{__variable.currencyCode}})",
                          "multipleItemsVariable": "purchasedRMs"
                        },
                        {
                          "value": "__item.price",
                          "text": "Price",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currency,{{{{__item.unitQuantity}}*{{__item.unitPrice}}}},{{__variable.currencyCode}})",
                          "multipleItemsVariable": "purchasedRMs"
                        },
                        {
                          "value": "__item.approvedAt",
                          "text": "Date Approved",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.approvedAt}})"
                        }
                      ],
                      "tableType": "static",
                      "showActions": true
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "RECEIVED",
              "bracketValueFormula": "fn(LENGTH,{{fetchedData.recieved.data}})",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "variable": "formData.revceivedPOTable",
                      "label": "RECEIVED",
                      "disabled": "FALSE",
                      "items": "fetchedData.recieved.data",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "PO #",
                          "type": "url",
                          "url": "fn(CONDITIONAL,fn(LOGICAL,'{{__item.type}}',===,'Spare Parts'),/add-spare-parts-purchase-order/{{__item._id}},/add-purchase-order/{{__item._id}})"
                        },
                        {
                          "value": "__item.supplier.name",
                          "text": "Supplier Name"
                        },
                        {
                          "value": "__item.purchasedRMs",
                          "text": "Raw Material/Spare Part",
                          "type": "formula",
                          "formula": "fn(CONDITIONAL,fn(NOT,{{__item.rawMaterial}}),{{__item.sparePart.description}},{{__item.rawMaterial.name}})",
                          "multipleItemsVariable": "purchasedRMs"
                        },
                        {
                          "value": "__item.unitQuantity",
                          "text": "Quantity",
                          "type": "formula",
                          "filterType": "unit",
                          "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterial.rawMaterialUnit}},'),==,'SQM'),{{fn(STANDARD_FUNCTIONS,kgToSQM,{{__item.unitQuantity}},{{__item.rawMaterial}})}},{{__item.unitQuantity}})",
                          "filterParam": "fn(CONDITIONAL,fn(NOT,{{__item.rawMaterial}}),{{__item.sparePart.unit}},{{__item.rawMaterial.rawMaterialUnit}})",
                          "multipleItemsVariable": "purchasedRMs"
                        },
                        {
                          "value": "__item.unitPrice",
                          "text": "Unit Price",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currency,fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterial.rawMaterialUnit}},'),==,'SQM'),{{fn(STANDARD_FUNCTIONS,priceKgToSQM,{{__item.unitPrice}},{{__item.rawMaterial}})}},{{__item.unitPrice}}),{{__variable.currencyCode}})",
                          "multipleItemsVariable": "purchasedRMs"
                        },
                        {
                          "value": "__item.price",
                          "text": "Price",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currency,{{{{__item.unitQuantity}}*{{__item.unitPrice}}}},{{__variable.currencyCode}})",
                          "multipleItemsVariable": "purchasedRMs"
                        },
                        {
                          "value": "__item.receivedAt",
                          "text": "Date Received",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.receivedAt}})"
                        }
                      ],
                      "tableType": "static",
                      "showActions": false,
                      "onRowClick": {
                        "type": "url",
                        "value": "/add-purchase-order/__item._id"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Upload Reciept PO Document",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "fetchedData.label",
                  "label": "Please upload document to mark the purchase order as received"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "table",
                  "variable": "fetchedData.poOrders",
                  "label": "Delivery Date",
                  "disabled": "FALSE",
                  "items": "fetchedData.selectedPo.purchasedRMs",
                  "tableType": "static",
                  "showActions": true,
                  "headers": [
                    {
                      "value": "__item.rawMaterial",
                      "text": "Name",
                      "formula": "fn(HELPER_FN,goodsName,{{__item.rawMaterial}})"
                    },
                    {
                      "value": "__item.unitQuantity",
                      "text": "Quantity",
                      "type": "formula",
                      "formula": "{{__item.unitQuantity}} {{__item.rawMaterial.rawMaterialUnit}}"
                    },
                    {
                      "value": "__item.unitPrice",
                      "text": "Unit Price",
                      "formula": "fn(HELPER_FN,currency,{{__item.unitPrice}},{{fetchedData.selectedPo.currencyCode}})"
                    },
                    {
                      "value": "__item.price",
                      "text": "Price",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,{{{{__item.unitQuantity}}*{{__item.unitPrice}}}},{{fetchedData.selectedPo.currencyCode}})"
                    }
                  ]
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "fileupload",
                  "variable": "fetchedData.poProof",
                  "label": "Document",
                  "disabled": "FALSE",
                  "color": "primary",
                  "previewType": "no-preview"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Submit",
              "onClick": [
                {
                  "executionOrder": 1,
                  "name": "pushPoData"
                },
                {
                  "executionOrder": 2,
                  "name": "sendRecievedPoProof"
                },
                {
                  "executionOrder": 3,
                  "name": "closePoReceiptProofPopup"
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "getSubmittedPOs"
      },
      {
        "executionOrder": 1,
        "name": "getApprovedPOs"
      },
      {
        "executionOrder": 1,
        "name": "getRecievedPOs"
      }
    ],
    "functions": [
      {
        "name": "getSubmittedPOs",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/purchaseorder/submitted",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.submitted"
      },
      {
        "name": "getApprovedPOs",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/purchaseorder/approved",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.approved"
      },
      {
        "name": "getRecievedPOs",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/purchaseorder/received",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.recieved"
      },
      {
        "name": "redirectToCreatePurchaseOrder",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/add-purchase-order"
      },
      {
        "name": "copySelectedTableItem",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__item",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedPo",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object"
      },
      {
        "name": "pushPoData",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "fetchedData.poProof",
        "arg2Key": "destinationKey",
        "arg2Value": "formData.uploadedProof"
      },
      {
        "name": "approvePO",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/purchaseorder/{{fetchedData.selectedPo._id}}/approve",
        "arg2Key": "postData",
        "arg2Value": "{}",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE"
      },
      {
        "name": "sendRecievedPoProof",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/purchaseorder/{{fetchedData.selectedPo._id}}/upload-proof",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE"
      },
      {
        "name": "completePo",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/purchaseorder/{{fetchedData.selectedPo._id}}/received",
        "arg2Key": "postData",
        "arg2Value": "{}",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE"
      },
      {
        "name": "openPoReceiptProofPopup",
        "type": "fnOpenPopup",
        "arg1Key": "popupName",
        "arg1Value": "Upload Reciept PO Document"
      },
      {
        "name": "closePoReceiptProofPopup",
        "type": "fnClosePopup",
        "arg1Key": "popupName",
        "arg1Value": "Upload Reciept PO Document"
      }
    ]
  },
  "forRole": "COMMERCIAL_MANAGER",
  "visible": true,
  "routerPriority": 100
}